import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        loading: Boolean
    }
    static targets = ['pageTrigger', 'pageLink'];

    initialize() {
        this.loading = false;
        this.observer = null;
        this.createObserver = this.createObserver.bind(this);
    }

    connect() {
        this.createObserver();
    }

    disconnect() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }

    createObserver() {
        if (!this.hasPageTriggerTarget) {
            return;
        }

        if (this.observer) {
            this.observer.disconnect();
        }

        this.observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && !this.loading) {
                this.loadMoreContent();
            }
        }, {
            root: null,
            threshold: 0,
        });

        this.observer.observe(this.pageTriggerTarget);
    }

    loadMoreContent() {
        const checkResults = parseInt(document.getElementById('checkResults').innerText);
        const currentSize = parseInt(document.getElementById('resultsNumber').value);
        
        if (!this.loading && checkResults >= currentSize) {
            this.loading = true;
            const batchSize = 12;
            const previousCount = currentSize;
            document.getElementById('resultsNumber').value = currentSize + batchSize;

            this.pendingLastFocusedIndex = this.getElementIndex(document.activeElement);
            this.pendingScrollAnchorIndex = previousCount > 0 ? previousCount - 1 : 0;

            let loadMoreFinished = false;
            const finishLoadMore = () => {
                if (loadMoreFinished) {
                    return;
                }
                loadMoreFinished = true;
                this.loading = false;
                if (this.pendingLastFocusedIndex >= 0) {
                    this.restoreFocus(this.pendingLastFocusedIndex);
                } else {
                    this.restoreScrollAnchor(this.pendingScrollAnchorIndex);
                }
            };

            document.addEventListener('turbo:before-stream-render', this.handleBeforeStreamRender.bind(this), { once: true });
            document.addEventListener('turbo:after-stream-render', finishLoadMore, { once: true });

            setTimeout(() => {
                const submitButton = document.getElementById("submit-button");
                submitButton.setAttribute('data-scrollTrigger', 'true');
                submitButton.click();
                submitButton.removeAttribute('data-scrollTrigger');

                setTimeout(finishLoadMore, 500);
            }, 100);
        }
    }
    
    getElementIndex(element) {
        if (!element || !element.parentNode) return -1;
        
        if (element.classList.contains('career-row')) {
            const careerRows = document.querySelectorAll('.career-row');
            return Array.from(careerRows).indexOf(element);
        }
        
        return -1;
    }
    
    handleBeforeStreamRender(event) {
        const targetId = event.target.getAttribute('target');
        if (targetId === 'career-search-turbo') {
            event.preventDefault();
            
            event.target.performAction();
        }
    }
    
    restoreScrollAnchor(anchorIndex) {
        const careerRows = document.querySelectorAll('.career-row');
        const anchor = careerRows[anchorIndex];
        if (anchor) {
            anchor.scrollIntoView({ block: 'nearest' });
        }
    }

    restoreFocus(lastFocusedIndex) {
        if (lastFocusedIndex < 0) {
            return;
        }

        const careerRows = document.querySelectorAll('.career-row');
        if (careerRows.length === 0) {
            return;
        }

        const indexToFocus = Math.min(lastFocusedIndex, careerRows.length - 1);
        if (careerRows[indexToFocus]) {
            careerRows[indexToFocus].focus();
        }
    }
}
